import ShortLink from 'components/shared/ShortLink/ShortLink'
import Tags from 'components/shared/Tags/Tags'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { withNamespaces } from 'react-i18next'

import Accordion from '../Accordion/Accordion'
import './Header.scss'

export const Header = ({
  locale,
  pathway: { title, subtitle, description, skills, slug, header = [] },
  t,
}) => {
  const [labels, setLabels] = useState([])

  useEffect(() => {
    if (skills) {
      setLabels(
        skills.map((s) =>
          t(`pathway.tags.${s.name.toLowerCase().split(' ').join('-')}`, {
            defaultValue: s.name,
          })
        )
      )
    }
  }, [skills, t])

  return (
    <div className="sc-pr-pathway-header">
      <div className="sc-pr-pathway-header__content">
        <h1>{subtitle ? `${title}: ${subtitle}` : title}</h1>
        <Tags locale={locale} labels={labels} />
        <p>{description}</p>
      </div>
      <div className="sc-pr-pathway-header__details">
        <Accordion locale={locale} headerData={header} />
        <ShortLink url={`rpf.io/${slug}`} />
      </div>
    </div>
  )
}

Header.propTypes = {
  locale: PropTypes.string.isRequired,
  pathway: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    description: PropTypes.string.isRequired,
    header: PropTypes.array.isRequired,
    skills: PropTypes.array,
    slug: PropTypes.string.isRequired,
  }).isRequired,
  t: PropTypes.func.isRequired,
}

export default withNamespaces('translations')(Header)
